import React from 'react';

interface SelectFieldProps {
  id: string;
  classname?: string;
  disabled?: boolean;
  label?: string;
  errors?: any;
  register: any;
  options: { value: string; label: string }[];
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  rules?: any;
  placeHolder?: string;
  defaultValue?: string;
}

const SelectField: React.FC<SelectFieldProps> = ({
  id,
  classname,
  disabled,
  label,
  errors,
  register,
  options,
  onChange,
  rules,
  placeHolder,
  defaultValue,
}) => {
  return (
    <div className="relative w-full">
      <select
        id={id}
        className={
          'peer block appearance-none rounded-lg border bg-transparent p-4 text-base text-black ' +
          (errors?.[id] ? ' border-2 border-scarletRed ' : ' border-foggyGray ') +
          classname
        }
        defaultValue={defaultValue}
        disabled={disabled}
        {...register(id, { onChange: onChange, ...rules })}
      >
        <option key={`${id}_placeHolder`} value="">
          {placeHolder}
        </option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <label
        htmlFor={id}
        className={
          'absolute start-1 top-2 ml-1 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-base duration-300 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4' +
          (errors?.[id] && ' text-scarletRed ')
        }
      >
        {label}
      </label>
      {errors?.[id] && <p className="absolute ml-1 mt-2 text-sm text-scarletRed">{errors[id]?.message}</p>}
    </div>
  );
};

export default SelectField;
